import { AutoVerifyEmailRedirect } from "@/features/auth/pages/authRedirects/auth.verifyEmail.redirect";

export const redirectRoutes = [
  {
    element: AutoVerifyEmailRedirect,
    path: "/verify-email/:email/:code", // route to news overview
  },
];
